/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';
	const itemBg = () => {
		if($('.kurashi-box-bg').length) {
			for(let i=0; i < $('.kurashi-box-bg').length; i++) {
				let img = $('.kurashi-box-bg').eq(i).data('img');
				$('.kurashi-box-bg').eq(i).css('background-image', 'url('+img+')');
			}
		}
	};
	const detail = () => {
		if($('.js-kurashi-other-contents').length) {
			const getJSONotherContents = (id) => {
				return $.getJSON(`/ajax/kurashi/detail/${id}.json`);
			};
			// 一件もない場合は要素ごと非表示
			if(!$('.rt_cf_n_related_news_id').length) {
				$('.kurashi-detail-other').addClass('di_none');
			}
			let itemArray = [];
			let ItemList = new Promise((resolve) => {
				let items;
				let count = 0;
				for(let i=0; i < $('.rt_cf_n_related_news_id').length; i++) {
					getJSONotherContents($('.rt_cf_n_related_news_id').eq(i).text()).then((data) => {
						let Html = '';
						// console.log(data.rt_bn_news_info[0],'data');
						// tag部分
						let categoryList = '';
						for(let l=0; l < data.rt_bn_news_info[0].cf_n_tags.length; l++) {
							let categoryHref = '';
							if(data.rt_bn_news_info[0].cf_n_tags[l].cf_nt_group_code === 'theme') {
								categoryHref = '/kurashi/list.html?p_tag1='+data.rt_bn_news_info[0].cf_n_tags[l]._key;
							} else if(data.rt_bn_news_info[0].cf_n_tags[l].cf_nt_group_code === 'product') {
								categoryHref = '/kurashi/list.html?p_tag2='+data.rt_bn_news_info[0].cf_n_tags[l]._key;
							} else if(data.rt_bn_news_info[0].cf_n_tags[l].cf_nt_group_code === 'color') {
								categoryHref = '/kurashi/list.html?p_tag3='+data.rt_bn_news_info[0].cf_n_tags[l]._key;
							} else if(data.rt_bn_news_info[0].cf_n_tags[l].cf_nt_group_code === 'room_type') {
								categoryHref = '/kurashi/list.html?p_tag4='+data.rt_bn_news_info[0].cf_n_tags[l]._key;
							}
							// console.log(categoryHref,'categoryHref',data.rt_bn_news_info[0].cf_n_tags[l].cf_nt_group_code);
							categoryList += '<li><a href="'+categoryHref+'" class="mod-label _keyword">'+
							data.rt_bn_news_info[0].cf_n_tags[l].cf_nt_name_d+
							'</a></li>';
						}
						Html += '<li class="pure-u-1-3 pure-u-md-1-1 space-u-40-child">'+
						'<div class="mod-box01 opacity">'+
						'<a href="'+data.rt_bn_news_info[0].rt_cf_n_href_kurahsi.href+'" class="di_block">'+
						'<figure>'+
						'<img src="'+data.rt_bn_news_info[0].rt_cf_n_img.src+'" class="width-u-100" alt="'+data.rt_bn_news_info[0].rt_cf_n_title.content[0]+'">'+
						'</figure>'+
						'</a>'+
						'<div class="_text">'+
						'<a href="'+data.rt_bn_news_info[0].rt_cf_n_href_kurahsi.href+'" class="di_block">'+
						'<h3 class="mod-head04 _border-main mt10">'+data.rt_bn_news_info[0].rt_cf_n_title.content[0]+'</h3>'+
						'</a>'+
						'<ul class="mod-labelWrap _10 pt10 _labelWrap">'+
						categoryList+
						'</ul>'+
						'</div>'+
						'<a href="'+data.rt_bn_news_info[0].rt_cf_n_href_kurahsi.href+'" class="_iconArrowWrap rt_cf_n_href_kurashi">'+
						'<span class="_icon"></span>'+
						'<svg class="_arrow"><use xlink:href="/common/svg/sprite.svg#arrow_right"></use></svg>'+
						'</a>'+
						'</div></li>';
						items = {
							itemsrc: Html,
							datatime: data.rt_bn_news_info[0].cf_n_date,
						};
						itemArray.push(items);
						count ++;
						if(count === $('.rt_cf_n_related_news_id').length) {
							return resolve(itemArray);
						}
					});
				}
			});
			Promise.all([ItemList]).then(() => {
				// 降順ソート
				// console.log(itemArray);
				itemArray.sort(function(itemA, itemB){
					if(itemA.datatime > itemB.datatime) return -1;
					if(itemA.datatime < itemB.datatime) return 1;
					return 0;
				});
				// 描画
				// console.log(itemArray);
				for(let i=0; i < itemArray.length; i++) {
					$('.js-kurashi-other-contents').append(itemArray[i].itemsrc);
				}
				setTimeout(function(){
					$('.js-kurashi-other-contents .mod-head04').matchHeight();
					$('.js-kurashi-other-contents figure').matchHeight();
					$('.js-kurashi-other-contents ._labelWrap').matchHeight();
				},200);
			});
		}
	};
	itemBg();
	detail();

})(window.jQuery, window.FUNCTIONS);
